import { UkoncenieVyhodnoteniaMpk, UkoncenieVyhodnoteniaMpkApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import PracovnyKrokEnum from '../../model/pracovnyKrok/PracovnyKrokEnum';

const client = new UkoncenieVyhodnoteniaMpkApi(apiConfiguration(elegislativaPrefixPath));

const map = (cisloLegislativnehoMaterialu: string, pracovnyKrok: PracovnyKrokEnum): UkoncenieVyhodnoteniaMpk => ({
  cisloLegislativnehoMaterialu,
  pracovnyKrok,
});

// eslint-disable-next-line import/prefer-default-export
export const cancelVyhodnotenieMpk = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: string,
  cisloLegMaterialu: string,
  pracovnyKrok: PracovnyKrokEnum,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.cancelVyhodnotenieMpk(
    type,
    year,
    index,
    pracovnyKrokId,
    map(cisloLegMaterialu, pracovnyKrok),
    headers,
  );
  return {
    responseCode: status,
  };
};
